import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import dotenv from 'dotenv';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';

import '@/core/index.css';
import { Landing } from '@/core/Landing';
import { ModalProvider } from '@/services/modal';
import { ThemeProvider } from '@/services/theme';
import { TranslationProvider } from '@/services/locale';
import { AppConfigProvider } from '@/core/AppConfig';
import { ScrollToTop } from '@/shared/components/ScrollToTop';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import { initSentry } from '@/shared/utils/initSentry';
import { ThemeOverride } from '@/shared/themes';
import { queryClient } from '@/core/queryClient';

dotenv.config();

initSentry();

const themeOverride: ThemeOverride = {
  common: {
    banner: {
      borderRadius: { default: '38px', tabletSM: '48px', tabletXL: '56px' },
      padding: '56px 56px 56px 0',
    },
    earnBanner: {
      borderRadius: '56px',
    },
  },
  colors: {
    background: {
      footer: '#101115',
    },
  },
};

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AppConfigProvider>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider override={themeOverride}>
            <ModalProvider>
              <TranslationProvider>
                <Router>
                  <ScrollToTop />
                  <Landing />
                </Router>
              </TranslationProvider>
            </ModalProvider>
          </ThemeProvider>
        </QueryClientProvider>
      </AppConfigProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
